// extracted by mini-css-extract-plugin
export default {"virtualDropdown":"ieCNBk"};